export const staMenuList = {
    namespaced: true,
    state: {
        menuList: []
    },
    mutations: {
        setMenuList: (state, payload) => state.menuList = payload
    },
    getters: {
        getMenuList: (state) => state.menuList,
    },
    actions: {

    }
}